import TransactionsListBanking from "./TransactionsListBanking";

export default TransactionsListBanking;
